import type { ReactNode } from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  icon?: LucideIcon;
}

export function EmptyState({ title, description, icon: Icon = Inbox }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-4 py-16 text-center">
      <span className="flex size-14 items-center justify-center rounded-full bg-brand-soft text-brand">
        <Icon className="size-7" aria-hidden />
      </span>
      <h2 className="text-base font-medium text-ink-strong">{title}</h2>
      {description && <p className="max-w-md text-sm text-muted">{description}</p>}
    </div>
  );
}
